import {BaseApiTemplateService, PagingResponseModel, ApiVisa} from '../../shared';
import {MembershipMasterDataContainerModel} from '../../../../../../models/aggregates/crm/membership-master-data';
import {Core2Config} from '../../shared';
import {HttpClient} from '@angular/common/http';
import {Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class MembershipMasterDataService extends BaseApiTemplateService<MembershipMasterDataContainerModel>{

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership/import-file-hdrs';

    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership/import-file-hdrs';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership/import-file-hdrs';
      this.httpClient = http;
    }

}